import styled from 'react-emotion'
import { Label } from 'shared/ui'

export const Section = styled('div')`
  padding: 24px;
  padding-top: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4e8ed;

  &:last-child {
    border: 0;
  }
`
export const SectionLabel = styled(Label)`
  margin-bottom: 10px;
`
